import { apiClient, ApiName } from '@shared/services/api'

export const fetchUser = (config) => {
  return apiClient.get(ApiName.ADMINS, 'super/users', config)
}

export const createAdminUser = (data) => {
  return apiClient.post(ApiName.ADMINS, 'super/users', data)
}

export const updateAdminUser = (data) => {
  return apiClient.put(ApiName.ADMINS, 'super/users', data)
}

export const deleteAdminUser = (id) => {
  return apiClient.delete(ApiName.ADMINS, 'super/users', id)
}
